// Generated by purs version 0.15.9
var hi = "Hi";
export {
    hi
};
